<div [ngClass]="stepViewConfig.tangerineBgColor" class="page-layout blank simple left-sidebar common-stepper fx-fill">
  <div class="top-bg accent"></div>

  <fuse-sidebar class="sidebar" name="page-sidebar" position="left" lockedOpen="gt-md">
    <div class="header p-24" [ngClass]="stepViewConfig.tangerineBgColor || 'accent'">
      <h2 class="m-0">{{stepViewConfig.title | translate}}</h2>
      @if (record && subtitle) {
        <span class='mt-0 h4 secondary-text'>{{subtitle | translate}}</span>
      }
    </div>
    <div class="content" [class.overview-visible]='showOverview'>
      @if (stepViewConfig.showOverview && record) {
        <div class="m-4 fx-row fx-justify-center fx-items-stretch">
          @if (showOverview) {
            <button [ngClass]="stepViewConfig.tangerineBgColor" mat-flat-button color='primary' style='width:160px;'>
              <span>Overview</span>
            </button>
          }
          @if (!showOverview) {
            <button mat-stroked-button [color]='stepViewConfig.tangerineBgColor || "primary"' style='width:160px;' (click)='onClickOverview()'>
              <span>Overview</span>
            </button>
          }
        </div>
      }

      <mat-vertical-stepper [selectedIndex]='stepperIndex' #stepper [linear]="isStepLinear" (click)='showOverview = false;buildSteps();' (selectionChange)='stepChange($event)'>
        @for (computedStep of computedSteps; track trackStepBy($index, computedStep)) {
          <mat-step [completed]='computedStep.completed'>
            <ng-template matStepLabel>
              <span [innerHTML]='computedStep.title | translate'></span>
            </ng-template>
          </mat-step>
        }
      </mat-vertical-stepper>
    </div>

  </fuse-sidebar>

  <div class="center">
    <div [ngClass]="stepViewConfig.tangerineBgColor" class="header accent p-24 header-mobile fx-row fx-justify-start fx-items-center fx-hide-gt-md">
      <button mat-icon-button (click)="toggleSidebar('page-sidebar')" class="sidebar-toggle mr-8 fx-hide-gt-md">
        <mat-icon>menu</mat-icon>
      </button>
      <div>
        <h2 class="m-0">{{stepViewConfig.title | translate}}</h2>
        @if (record && subtitle) {
          <span class='mt-0 h4 secondary-text'>{{subtitle | translate}}</span>
        }
      </div>
    </div>
    <div class="content p-24">
      @if (showOverview) {
        @switch (datasetACS.datasetCode) {
          @case ("trip_packages") {
            <trip-package-overview></trip-package-overview>
          }
        }
      }
      @if (!showOverview) {
        <mat-tab-group class='tab-hidden-header' [selectedIndex]='stepIndex'>
          @for (stepConfig of steps; track stepConfig; let i = $index) {
            <mat-tab>
              <ng-template matTabContent>
                <h2><button class='circular-flat-button only_tangerine_bg' mat-flat-button [color]="stepViewConfig.tangerineBgColor || 'accent'">{{i + 1}}</button> {{stepConfig.title | translate}}</h2>
                @switch (stepConfig.component) {
                  <!-- ENTITY STEPS -->
                  @case ("entity-types-step") {
                    <entity-types-step
                      (nextStep)='stepper.next()'
                      (prevStep)='stepper.previous()'
                      [hasNext]='i + 1 < steps.length'
                      [hasPrevious]='i > 0'
                    ></entity-types-step>
                  }
                  @case ("entity-b2b-step") {
                    <entity-b2b-step
                      (nextStep)='stepper.next()'
                      (prevStep)='stepper.previous()'
                      [hasNext]='i + 1 < steps.length'
                      [hasPrevious]='i > 0'
                    ></entity-b2b-step>
                  }
                  <!-- TRIP PACKAGES STEPS -->
                  @case ("trip-package-step-1") {
                    <trip-package-step-1
                      [parentDatasetRS]='datasetRS'
                      (nextStep)='stepper.next()'>
                    </trip-package-step-1>
                  }
                  @case ("trip-package-step-2") {
                    <trip-package-step-2
                      [parentDatasetRS]='datasetRS'
                      [parentDatasetACS]='datasetACS'
                    ></trip-package-step-2>
                  }
                  @case ("trip-package-step-3") {
                    <trip-package-step-3
                      [parentDatasetRS]='datasetRS'
                      [parentDatasetACS]='datasetACS'
                      (nextStep)='stepper.next()'
                      (prevStep)='stepper.previous()'
                      [hasNext]='i + 1 < steps.length'
                      [hasPrevious]='i > 0'
                    ></trip-package-step-3>
                  }
                  @case ("trip-package-step-4") {
                    <trip-package-step-4
                      (nextStep)='stepper.next()'
                      (prevStep)='stepper.previous()'
                      [hasNext]='i + 1 < steps.length'
                      [hasPrevious]='i > 0'
                    ></trip-package-step-4>
                  }
                  @case ("trip-package-integrations-step") {
                    <integrations-step
                      [parentDatasetACS]='datasetACS'
                      (nextStep)='stepper.next()'
                      (prevStep)='stepper.previous()'
                      [hasNext]='i + 1 < steps.length'
                      [hasPrevious]='i > 0'
                      [datasetCode]='"trip_packages"'
                      [integrationsDatasetCode]='"trip_package_integrations"'
                    ></integrations-step>
                  }
                  @case ("trip-package-reselled-step-0") {
                    <trip-package-reselled-step-0
                      (nextStep)='stepper.next()'
                      (prevStep)='stepper.previous()'
                      [hasNext]='i + 1 < steps.length'
                      [hasPrevious]='i > 0'
                      [stepConfig]='stepConfig'
                      >
                    </trip-package-reselled-step-0>
                  }
                  @case ("trip-package-reselled-step-2") {
                    <trip-package-reselled-step-2
                      (nextStep)='stepper.next()'
                      (prevStep)='stepper.previous()'
                      [hasNext]='i + 1 < steps.length'
                      [hasPrevious]='i > 0'
                      [stepConfig]='stepConfig'
                      [formConfig]='stepConfig.options.formConfig'
                    ></trip-package-reselled-step-2>
                  }
                  @case ("trip-package-reselled-step-3") {
                    <trip-package-reselled-step-3
                      (nextStep)='stepper.next()'
                      (prevStep)='stepper.previous()'
                      [hasNext]='i + 1 < steps.length'
                      [hasPrevious]='i > 0'
                    ></trip-package-reselled-step-3>
                  }
                  <!-- USER ROLE PERMISSION STEP -->
                  @case ("user-role-permission-step") {
                    <user-role-permission-step
                      (nextStep)='stepper.next()'
                      (prevStep)='stepper.previous()'
                      [hasNext]='i + 1 < steps.length'
                      [hasPrevious]='i > 0'
                    ></user-role-permission-step>
                  }
                  <!-- DOMAIN USER ROLE PERMISSION STEP -->
                  @case ("domain-user-role-permission-step") {
                    <domain-user-role-permission-step
                      (nextStep)='stepper.next()'
                      (prevStep)='stepper.previous()'
                      [hasNext]='i + 1 < steps.length'
                      [hasPrevious]='i > 0'
                    ></domain-user-role-permission-step>
                  }
                  <!-- GENERIC STEPS -->
                  @case ("common-form-step") {
                    <common-form-step
                      [stepConfig]='stepConfig'
                      [stepIndex]='i'
                      (nextStep)='stepper.next()'
                      [hasNext]='i + 1 < steps.length'
                      [hasPrevious]='i > 0'
                    ></common-form-step>
                  }
                  @case ("common-date-step") {
                    <common-date-step
                      [stepConfig]='stepConfig'
                      [stepIndex]='i'
                      (nextStep)='stepper.next()'
                      [hasNext]='i + 1 < steps.length'
                      [hasPrevious]='i > 0'
                    ></common-date-step>
                  }
                  @case ("common-sub-dataset-form-step") {
                    <common-sub-dataset-form-step
                      [parentDatasetACS]='datasetACS'
                      [parentDatasetRS]='datasetRS'
                      [stepConfig]='stepConfig'
                      [stepIndex]='i'
                      [hasNext]='i + 1 < steps.length'
                      [hasPrevious]='i > 0'
                      (nextStep)='stepper.next()'>
                    </common-sub-dataset-form-step>
                  }
                  @case ("common-data-viewer-step") {
                    <common-data-viewer-step
                      [stepConfig]='stepConfig'
                      [stepIndex]='i'
                      [hasNext]='i + 1 < steps.length'
                      [hasPrevious]='i > 0'
                      (nextStep)='stepper.next()'
                    ></common-data-viewer-step>
                  }
                  @case ("common-blocks-step") {
                    <common-blocks-step
                      [stepConfig]='stepConfig'
                      [hasNext]='i + 1 < steps.length'
                      [hasPrevious]='i > 0'
                      [stepIndex]='i'
                      (nextStep)='stepper.next()'
                    ></common-blocks-step>
                  }
                  @case ("common-sub-dataset-blocks-step") {
                    <common-sub-dataset-blocks-step
                      [stepConfig]='stepConfig'
                      [parentDatasetACS]='datasetACS'
                      [parentDatasetRS]='datasetRS'
                      (nextStep)='stepper.next()'
                      [stepIndex]='i'
                      [hasNext]='i + 1 < steps.length'
                      [hasPrevious]='i > 0'
                    ></common-sub-dataset-blocks-step>
                  }
                  @case ("common-i18n-form-step") {
                    <common-i18n-form-step
                      [stepConfig]='stepConfig'
                      [formConfig]='stepConfig.options.formConfig'
                      (nextStep)='stepper.next()'
                      [parentDatasetACS]='datasetACS'
                      [parentDatasetRS]='datasetRS'
                      [hasNext]='i + 1 < steps.length'
                      [hasPrevious]='i > 0'
                    ></common-i18n-form-step>
                  }
                  @case ("common-i18n-data-viewer-step") {
                    <common-i18n-data-viewer-step
                      [stepConfig]='stepConfig'
                      [formConfig]='stepConfig.options.formConfig'
                      (nextStep)='stepper.next()'
                      [parentDatasetACS]='datasetACS'
                      [parentDatasetRS]='datasetRS'
                      [hasNext]='i + 1 < steps.length'
                      [hasPrevious]='i > 0'
                    ></common-i18n-data-viewer-step>
                  }
                  @case ("common-i18n-blocks-step") {
                    <common-i18n-blocks-step
                      [stepConfig]='stepConfig'
                      [stepIndex]='i'
                      [parentDatasetACS]='datasetACS'
                      [parentDatasetRS]='datasetRS'
                      (nextStep)='stepper.next()'
                      (prevStep)='stepper.previous()'
                      [hasNext]='i + 1 < steps.length'
                      [hasPrevious]='i > 0'
                    ></common-i18n-blocks-step>
                  }
                  @case ("common-map-step") {
                    <common-map-step
                      [stepConfig]='stepConfig'
                      [stepIndex]='i'
                      (nextStep)='stepper.next()'
                      [hasNext]='i + 1 < steps.length'
                      [hasPrevious]='i > 0'
                    ></common-map-step>
                  }
                  <!-- TRIP CATEGORY STEP -->
                  @case ("trip-category-integrations-step") {
                    <integrations-step
                      [parentDatasetACS]='datasetACS'
                      (nextStep)='stepper.next()'
                      (prevStep)='stepper.previous()'
                      [hasNext]='i + 1 < steps.length'
                      [hasPrevious]='i > 0'
                      [datasetCode]='"trip_categories"'
                      [integrationsDatasetCode]='"trip_category_integrations"'
                    ></integrations-step>
                  }
                  @default {
                    <div>
                      <p>{{'Componente non configurato' | translate}} {{stepConfig.component}}</p>
                    </div>
                  }
                }
              </ng-template>
            </mat-tab>
          }
        </mat-tab-group>
      }
    </div>

  </div>

</div>